import { mapState } from 'vuex';
import {
  ApartmentDTO,
  EntrancePlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import { PropType, ref } from 'vue';
import { Options, Vue } from 'vue-class-component';
import KeypadCodeInput from '@/views/components/KeypadCodeInput/KeypadCodeInput.vue';
import { getAllKeypadCodes } from '@/core/utils/EntrancePlant/entrance-plant.utils';
@Options({
  name: 'CodeSection',
  props: {
    editingApartment: {
      type: Object as PropType<ApartmentDTO>,
      required: true,
    }, 
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: { KeypadCodeInput },
  emits: ['key-code-edited', 'error-key-code'],
})
export default class CodeSection extends Vue {
  editingApartment!: ApartmentDTO;
  currentEntrancePlant!: EntrancePlantDetailDTO;
  codeTabHasError = false;
  keypadCodeEdited = false;
  keypadCode = '';

  get alreadyUsedCodes() {
    return getAllKeypadCodes(this.currentEntrancePlant);
  }

  created() {
    if (this.editingApartment.keypadCode)
      this.keypadCode = this.editingApartment.keypadCode;
  }

  apartmentWasEdited() {
    this.$emit('error-key-code', this.codeTabHasError);
    this.$emit('key-code-edited', this.keypadCodeEdited, this.keypadCode);
  }

  handleKeypadCodeEdited(value: boolean, code: string) {
    this.keypadCodeEdited = value;
    if (!this.codeTabHasError) {
      this.keypadCode = code;
      this.apartmentWasEdited();
    }
  }

  handleErrorKeyCode(value: boolean) {
    this.codeTabHasError = value;
    this.apartmentWasEdited();
  }
}
